const columnsTypeLabelMap: Record<string, string> = {
  status: "Status",
  submission: "Submission Date",
  response: "Response",
  responseId: "Response ID",
};

export default columnsTypeLabelMap;
